import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Instagram, Facebook } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-charcoal text-ivory">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo & Description */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center mb-4">
              <img
                src="/saxDJLOGO.webp"
                alt="Sax&DJ — Saxophone et DJ pour mariages et événements"
                className="h-16 w-auto"
              />
            </div>
            <p className="text-warm-gray mb-6 max-w-md">
              Créateur d'ambiances uniques pour vos mariages et événements privés. 
              L'alliance parfaite entre l'élégance du saxophone et l'énergie du DJ.
            </p>
            <div className="flex space-x-4">
              <a
                href="https://www.instagram.com/sax_dj_kruegerkevin/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-warm-gray hover:text-gold transition-colors p-2 hover:bg-white/10 rounded-lg"
                aria-label="Instagram Sax&DJ"
              >
                <Instagram className="h-5 w-5" />
              </a>
              <a 
                href="#" 
                className="text-warm-gray hover:text-gold transition-colors p-2 hover:bg-white/10 rounded-lg"
                aria-label="Facebook"
              >
                <Facebook className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Navigation</h3>
            <ul className="space-y-2">
              {[
                { name: 'Accueil', href: '/' },
                { name: 'À propos', href: '/about' },
                { name: 'Services', href: '/services' },
                { name: 'Portfolio', href: '/portfolio' },
                { name: 'Soirées entreprise', href: '/soirees-entreprise' },
                { name: 'Blog', href: '/blog' },
                { name: 'Contact', href: '/contact' }
              ].map((item) => (
                <li key={item.name}>
                  <Link 
                    to={item.href}
                    className="text-warm-gray hover:text-gold transition-colors"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold mb-4">Contact</h3>
            <div className="space-y-3">
              <div className="flex items-center space-x-3 text-warm-gray">
                <Mail className="h-4 w-4 text-gold" />
                <span className="text-sm">contact@sax-dj.fr</span>
              </div>
              <div className="flex items-center space-x-3 text-warm-gray">
                <Phone className="h-4 w-4 text-gold" />
                <span className="text-sm">06.61.94.42.26</span>
              </div>
              <div className="flex items-center space-x-3 text-warm-gray">
                <MapPin className="h-4 w-4 text-gold" />
                <span className="text-sm">Île-de-France & régions</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-warm-gray/20 mt-8 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-center">
            <p className="text-warm-gray text-sm">
              © 2026 Sax&DJ Events. Tous droits réservés.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};